module.exports = __webpack_public_path__ + "static/media/rexel-product.79e20271.png";